<template>
  <div class="InputAlibabaProd">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">開始代購吧</a>
        <button type="button" class="btn btn-primary" @click="goToQueryProds()">
          查詢存擋網址
        </button>
      </nav>

      <div class="title pt-3">加入委託代購商品</div>
      <ul class="list-group">
        <div class="card">
          <div class="card-body">
            <p>
              阿里巴巴網址範例:
              <br />https://detail.1688.com/offer/800120939317.html 或
              https://m.1688.com/offer/800120939317.html
            </p>
            <p>
              請將阿里巴巴(1688)中國購物平台商品網址複製後，貼入下方輸入框，在點選「加入商品」:
            </p>
            <input type="text" class="form-control" v-model="searchUrl" />
            <br />
            <button
              class="btn btn-primary btn-block"
              v-on:click="clickSearchUrl()"
            >
              確認儲存商品
            </button>
          </div>
        </div>
      </ul>

      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'
export default {
  name: 'alibabaorder',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      displayViews: null,
      skuInfo: [],
      buyBaseLine: 1,
      isLoading: true,
      searchUrl: '',
      mapInfo: null,
      prodInfos: {},
      ProdInfosArray: [],
      inputAmounts: [],
      colorSelected: null,
      selectedStore: 'UNIMARTC2C',
      checkMobile: isMobile ? '1' : '0',
      prodDetail: '',
      ignoreBaseLine: true,
      addToCartCount: 0,
    }
  },
  methods: {
    clickSearchUrlFormat: function (url) {
      const vm = this
      // https: //detail.1688.com/offer/571008951577.html 或
      //   https: //m.1688.com/offer/571008951577.html 或
      // http://detail.m.1688.com/page/index.htm?offerId=601733052815

      let aibabaRegexs = []
      let isAibabaUrl = false
      let desktopAibabaRegex = /detail.1688.com\/offer\/[0-9]{8,12}/g
      let mobileAibabaRegex = /m.1688.com\/offer\/[0-9]{8,12}/g
      let mobileAppAibabaRegex =
        /detail.m.1688.com\/page\/index\.htm\?offerId=[0-9]{8,12}/g

      aibabaRegexs.push(desktopAibabaRegex)
      aibabaRegexs.push(mobileAibabaRegex)
      aibabaRegexs.push(mobileAppAibabaRegex)

      let checkMatchAibabaUrl = []
      let matchAibabaOfferId = ''
      aibabaRegexs.forEach(aibabaRegex => {
        checkMatchAibabaUrl = url.match(aibabaRegex)

        if (
          checkMatchAibabaUrl != undefined &&
          checkMatchAibabaUrl.length != 0
        ) {
          if (checkMatchAibabaUrl[0].split('offer/')[1] != undefined) {
            matchAibabaOfferId = checkMatchAibabaUrl[0].split('offer/')[1]
          } else if (checkMatchAibabaUrl[0].split('offerId=')[1] != undefined) {
            matchAibabaOfferId = checkMatchAibabaUrl[0].split('offerId=')[1]
          } else {
            isAibabaUrl = false
          }

          isAibabaUrl = true
        }
      })

      if (isAibabaUrl) {
        vm.searchUrl =
          'https://detail.1688.com/offer/' + matchAibabaOfferId + '.html'

        return true
      } else {
        vm.$toast.open({
          message: '輸入的 ' + vm.searchUrl + ' 網址格式錯誤',
          type: 'error',
        })
        vm.isLoading = false
        return false
      }
    },
    clickSearchUrl: function () {
      const vm = this
      vm.isLoading = true

      let urlIsValid = vm.clickSearchUrlFormat(vm.searchUrl)

      if (urlIsValid) {
        let formData = {
          parseUrl: vm.searchUrl,
        }
        axios
          .post(vm.apiUrl + 'InputDataToDb', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            vm.displayViews = response.data
            // console.log(JSON.stringify(vm.displayViews));
            if (vm.displayViews.error) {
              vm.$toast.open({
                message: '商品已經存在，單號為:' + vm.displayViews.orderid,
                type: 'success',
              })
            } else {
              vm.$toast.open({
                message: '存擋成功，委託單號:' + vm.displayViews.orderid,
                type: 'success',
              })
            }

            vm.isLoading = false
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '存擋失敗: ' + error,
              type: 'error',
            })
            vm.$modal.show('dialog', {
              title: '🙋請聯絡客服',
              text: '請聯絡客服⚡ 告訴我們您存擋發生了問題!',
              buttons: [
                {
                  title: '👉聯絡客服',
                  handler: () => {
                    window.location = 'https://m.me/2266831083395361'
                  },
                },
              ],
            })
            vm.isLoading = false
          })
      }
    },
    goToQueryProds: function () {
      const vm = this
      vm.$router.push('queryinputalibabaprods')
    },
  },
  watch: {},
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = false
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
}
</script>
